module.exports = __webpack_public_path__ + "img/enviro-coin.b4bc46f8.jpg";